import React from "react";
import "./styles/global.scss"; // Import your global styles here
import AppRouter from "./routes/AppRouter";
import { ModalProvider } from "./context/ModalContext";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<div>Loading...</div>}>
        <ModalProvider>
          <ToastContainer />
          <div className="bg-white dark:bg-black">
            <AppRouter />
          </div>
        </ModalProvider>
      </Suspense>
    </I18nextProvider>
  );
}

export default App;
